import { Box } from '@chakra-ui/react';
import { AppInstallQR } from '../../../ui/AppInstallQR';
import { MobileAccessQR } from '../../../ui/MobileAccessQR';

/**
 * Bower on your phone: a QR that gets the mobile app, with the credential-free
 * web QR one tap away for anyone who would rather not install it. It carries
 * no destination: the phone has its own "Save to…".
 */
export function PhoneBody() {
  return (
    <Box py={2}>
      <AppInstallQR src="create_modal" size={180} browserFallback={<MobileAccessQR size={180} />} />
    </Box>
  );
}
